import moment from 'moment';
import { RouteDelay } from './types';

export const delayCalculator = (exactDeliveryTime: string, delays: RouteDelay[]) => {
  const exactDeliveryTimeMoment = moment(exactDeliveryTime, 'HH:mm');

  const delaysToApply: RouteDelay[] = delays.filter((delay: RouteDelay) =>
    moment(delay.time, 'HH:mm').isBefore(exactDeliveryTimeMoment)
  );

  const totalDelay = delaysToApply.reduce((acc, current) => acc + current.duration_in_minutes, 0);

  return totalDelay;
};
